export default __webpack_public_path__ + "static/media/introIllustration.9f2f540e.png";